import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface UpdUserRequest {
  IdUser: number;
  UserName: string;
  Email: string;
  NewPassword?: string; 
  Roles: number[];
}

export const updateUser = async (userData: UpdUserRequest) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/upt-user`;
    
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token no disponible');

    console.log(userData,"akhfbsgbvfh")

    const response = await axios.post(
      endpoint,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error en updateUser:', error);
    
    // Manejo detallado de errores
    if (axios.isAxiosError(error)) {
      const serverError = error.response?.data;
      throw new Error(serverError?.message || 'Error al actualizar usuario');
    }
    
    throw new Error('Error de conexión');
  }
};